import { RouteRecordRaw } from "vue-router";

export default [
  {
    path: "/:path(.*)*",
    name: "PageNotFound",
    component: () => import("/@/views/error/Page404.vue"),
    meta: {
      title: "404 Not Found",
      ignoreAuth: true,
      hideMenu: true,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("/@/views/login/LoginPage.vue"),
    meta: {
      title: "登录",
      ignoreAuth: true,
      hideMenu: true,
    },
  },
] as RouteRecordRaw[];
